export default __webpack_public_path__ + "static/media/clock (2) 2.e04f889b.svg";